export default __webpack_public_path__ + "static/media/Avatar-29.10922d57.svg";